import { useHistory } from "react-router-dom";
import { Button, Page } from "@common-ui/ui";
import { Auth } from "aws-amplify";
import { useEffect, useState } from "react";

import { Header } from "../../components";
import { UserOrgsTreeViewWrapper } from "./UserOrgsTreeViewWrapper";
import { AddCircle } from "@mui/icons-material";

export const UserOrgsTreeView = () => {
  const [isPlatformAdmin, setPlatformAdmin] = useState("");
  let history = useHistory();

  useEffect(() => {
    async function fetchData() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        setPlatformAdmin(user?.attributes["custom:plat_admin"]);
      } catch (error) {
        history && history.push("/sign-in");
      }
    }
    fetchData();
  }, [history]);

  return (
    <Page title="FlukeWorks">
      <Header
        xl
        name="Organizations"
        history={history}
        action={
          isPlatformAdmin?.toString() === "true" ? (
            <Button
              variant="contained"
              color="secondary"
              startIcon={<AddCircle />}
              onClick={() => history.push(`/toplevelorg`)}
              style={{ textTransform: "normal !important" }}
            >
              Create New
            </Button>
          ) : (
            ""
          )
        }
      />
      <UserOrgsTreeViewWrapper />
    </Page>
  );
};
